<template>
  <div class="intro-container">
    <h1 class="intro-title">사주로 풀어보는 MBTI란?</h1>
    <p class="intro-description">
      사주로 풀어보는 MBTI 서비스는
      동양철학의 <strong>기질 분류 체계(사주)</strong>와 현대 심리학의 <strong>성격 분류 체계(MBTI)</strong>의 접점을 찾아
      설문에 흔들리지 않는 안정적인 MBTI 해석을 추구합니다.
      단순 설문 의존적이어서 순간 기분이나 상황에 따라 달라질 수 있는 MBTI와 달리
      사주에 기반한 타고난 기질 해석을 통한 안정적인 성향 분석을 해드립니다. ({{ LYD }}LYD 필요)
    </p>

    <div class="intro-actions">
      <label class="checkbox">
        <input type="checkbox" v-model="skipNext" />
        다시 보지 않기
      </label>
      <div class="buttons">
        <button @click="proceed">이용하기</button>
        <button @click="cancel">돌아가기</button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'

  const LYD = ref(import.meta.env.VITE_CHARGE_MBTI)
  const router = useRouter()
  const skipNext = ref(false)
  const storageKey = 'skipIntroMBTI'
  const proceedTo = '/SetupSajuData?from=IntroMBTI'

  function proceed() {
    if (skipNext.value) {
      localStorage.setItem(storageKey, 'true')
    }
    router.replace(proceedTo)
  }

  function cancel() {
    router.go(-1)
  }

  onMounted(() => {
    if (localStorage.getItem(storageKey) === 'true') {
      router.replace(proceedTo)
    }
  })
</script>

<style scoped>
  .intro-container {
    min-height: 100vh;
    width: var(--device-width);
    max-width: 480px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1.2rem;
    box-sizing: border-box;
    text-align: center;
  }

  .intro-title {
    font-size: var(--font-size-16);
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  .intro-description {
    font-size: var(--font-size-11);
    line-height: 1.6;
    margin-bottom: 2rem;
    width: 90%;
  }
  .intro-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .checkbox {
    font-size: var(--font-size-09);
  }

  .buttons {
    display: flex;
    gap: 1.2rem;
  }

  button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #333;
    color: white;
    cursor: pointer;
  }

  button:first-child {
    background-color: #4caf50; /* Green */
    color: white;
  }

  button:first-child:hover {
    background-color: #45a049;
  }

  button:last-child {
    background-color: #f44336; /* Red */
    color: white;
  }

  button:last-child:hover {
    background-color: #da190b;
  }
</style>
